
import audioManager from "../main/media/audio-manager"
import mediaManager from "../main/media/media-manager"
import whiteBoardManger from "../main/media/white-board-manager"
import videoManager from "../main/media/video-manager";


export function initMedia(hstRtcEngine) {
  /**
   * 开始广播本地媒体
   * @param {*} mediaType 
   * @param {*} mediaId 
   * @param {*} params
   * @returns 无
   */
  hstRtcEngine.prototype.startPublishMedia = function(mediaType, mediaId, params) {
    mediaManager.startPublishMedia(mediaType, mediaId, params)
  };

  /**
   * 停止广播本地媒体
   * @param {*} mediaType 
   * @param {*} mediaId
   * @returns 无 
   */
  hstRtcEngine.prototype.stopPublishMedia = function(mediaType, mediaId) {
    mediaManager.stopPublishMedia(mediaType, mediaId);
  };

  /**
   * 开始接收远端媒体
   * @param {*} userId 
   * @param {*} mediaType 
   * @param {*} mediaId 
   * @returns Promise
   */
  hstRtcEngine.prototype.startReceiveMedia = function(userId, mediaType, mediaId) {
    return mediaManager.startReceiveMedia(userId, mediaType, mediaId)
  };

  /**
   * 停止接收远端媒体
   * @param {*} userId 
   * @param {*} mediaType 
   * @param {*} mediaId 
   * @returns Promise
   */
  hstRtcEngine.prototype.stopReceiveMedia = function(userId, mediaType, mediaId) {      
    return mediaManager.stopReceiveMedia(userId, mediaType, mediaId);
  };

  /**
   * 设置媒体渲染器
   * @param {*} userId      用户ID，可以是本地用户或远端用户 
   * @param {*} mediaType   媒体类型：音频、视频、屏幕共享、电子白板
   * @param {*} mediaId     媒体ID
   * @param {*} htmlEle     HTML标签，对于白板来说是canvas，其它是video
   * @param {*} params      控制本地采集分辨率和帧率 
   */
  hstRtcEngine.prototype.setMediaRender = function(userId, mediaType, mediaId, htmlEle, params) {
    mediaManager.setMediaRender(userId, mediaType, mediaId, htmlEle, params);
  };

  /**
   * 设置本地视频渲染
   * @param {*} mediaId     媒体ID
   * @param {*} htmlEle     HTML标签，它是video
   * @param {*} params      控制本地采集分辨率和帧率 
   */
   hstRtcEngine.prototype.setLocalVideoRender = function(mediaId, htmlEle, params) {
    return mediaManager.setLocalVideoRender(mediaId, htmlEle, params);
  };

  /**
   * 取消设置媒体渲染器
   * @param {*} userId 
   * @param {*} mediaType FIXME：音频和视频都传入MediaType？
   * @param {*} htmlEle 
   */
  hstRtcEngine.prototype.unsetMediaRender = function(userId, mediaType, htmlEle, mediaId) {
    mediaManager.unsetMediaRender(userId, mediaType, htmlEle);
  };

  /**
   * 获取媒体设备列表
   * @returns 设备列表
   */
  hstRtcEngine.prototype.getMediaDevices = async function () {
    return mediaManager.getMediaDevices();
  };

  /**
   * 选择扬声器设备
   * @param {*} devId 
   */
  hstRtcEngine.prototype.chooseSpkDevice = function (devId) {
    return audioManager.chooseSpkDevice(devId)
  };

  /**
   * 
   * @param {*} value 设置变声开关
   */
  hstRtcEngine.prototype.setMagicAudioSwitch = function(value) {
    audioManager.setMagicAudioSwitch(value)
  };

  /**
   * 设置本地是否发送变声
   * @param {*} value 变声程度值，取值范围为[-12, 12]，0表示没有变声
   */
  hstRtcEngine.prototype.setSendMagicAudioValue = function(value) {
    audioManager.setSendMagicAudioValue(value)
  };

  /**
   * 设置是否接收变声
   * @param {*} mode 0：跟随，1：只接原声，2：只接变声
   */
  hstRtcEngine.prototype.setRecvMagicAudioMode = function(mode) {
    audioManager.setRecvMagicAudioMode(mode)
  };

  /**
   * 获取流统计数据
   * @param {*} params 
   */
  hstRtcEngine.prototype.getStreamStats = function (params, callback, interval, userData) {
    return mediaManager.getStreamStats(params, callback, interval, userData);
  };

  /**
   * 创建白板
   */
  hstRtcEngine.prototype.createWhiteBoard = function (params) {
    return whiteBoardManger.createWhiteBoard(params);
  }

  hstRtcEngine.prototype.getWhiteBoard = function (params) {
    return whiteBoardManger.getWhiteBoard(params)
  }

  /**
   * 关闭白板
   * @param {*} mediaId 
   */
  hstRtcEngine.prototype.closeWhiteBoard = function (mediaId) {
    return whiteBoardManger.closeWhiteBoard(mediaId);
  }

  /**
   * 设置白板显示模式
   * @param {*} mediaId 指定白板，为null表示所有白板
   * @param {*} mode 1：等比完整，2：等比适应，3：等比缩放
   * @param {*} param mode为3时，指定缩放比例
   */
  hstRtcEngine.prototype.setWhiteBoardDisplayMode =  function(mediaId, mode, param) {
    return whiteBoardManger.setDisplayMode(mediaId, mode, param);
  }
  /**
   * 上传文档
   */
  hstRtcEngine.prototype.startUpload = function (params) {
    return whiteBoardManger.startUploadDoc(params)
  }
  /**
   * 切换媒体设备 支持麦克风和视频切换
   * @param {*} mediaType 
   * @param {*} mediaId 
   * @param {*} devId 
   */
  hstRtcEngine.prototype.switchDevice = function (mediaType, mediaId, devId, videoParam) {
    return mediaManager.switchDevice(mediaType, mediaId, devId, videoParam)
  }

  /**
   * 获取本地音频状态
   * @param {*} callback 
   * @param {*} interval 
   * @return  promise 
   */
  hstRtcEngine.prototype.getLocalAudioStats = function (mediaId, callback, interval) {
    return audioManager.getLocalAudioStats(mediaId, callback, interval)
  }
  /**
   * 切换分辨率
   * @param {*} mediaId 媒体id
   * @param {*} videoParam 摄像头参数
   */
  hstRtcEngine.prototype.switchResolution = function (mediaId, videoParam) {
    return mediaManager.switchResolution(mediaId, videoParam)
  }

  hstRtcEngine.prototype.setVideoParam = function (mediaId, videoParam) {
    videoManager.setVideoParam(mediaId, videoParam);
  }
}
